import clsx from "clsx";
import { ReactNode } from "react";

interface PageBodyProps {
  roundedTop?: boolean;
  roundedBottom?: boolean;
  padding?: boolean | "x" | "y";
  children?: ReactNode;
}

function PageBody({ roundedTop = true, roundedBottom, padding = true, children }: PageBodyProps) {
  return (
    <div
      className={clsx(
        padding === true && "p-5 lg:p-10",
        padding === "x" && "px-5 lg:px-10",
        padding === "y" && "py-5 lg:py-10",
        roundedTop && "lg:rounded-t-2xl",
        roundedBottom && "lg:rounded-b-2xl",
        "grow flex flex-col z-10",
        "bg-[#303549]/30 text-white w-full max-w-[1680px] mx-auto"
      )}
    >
      {children}
    </div>
  );
}

export default PageBody;
